import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardPanelStyleId = 'wb-v2-board-panel-theme';

export const boardPanelBridgeStyles = {
  'board-panel .board-panel': {
    '--local-board-panel-title-color': tokens.color.text.primary,
    '--local-board-panel-title-font-family': tokens.font.family.body,
    '--local-board-panel-title-font-size': tokens.font.size.textSm,
    '--local-board-panel-title-font-weight': tokens.font.weight.semibold,
    '--local-board-panel-title-line-height': tokens.lineHeight.textSm,
    '--local-board-panel-head-gap': tokens.spacing.sm,
    '--local-board-panel-head-actions-gap': tokens.spacing.xxs,
    '--local-board-panel-step-color': tokens.color.text.tertiary,
    '--local-board-panel-step-font-size': tokens.font.size.textXs,
    '--local-board-panel-step-line-height': tokens.lineHeight.textXs,
  },
};
